// Shared tooltip/grid/axis styling for all chart wrappers so the 5 chart
// types read as one consistent system, themed via mo3tiThemes conventions.
export const getChartTheme = (theme) => {
  const isDark = theme === "dark";
  return {
    isDark,
    grid: isDark ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.06)",
    axis: isDark ? "rgba(255,255,255,0.5)" : "rgba(30,41,59,0.55)",
    tooltipStyle: {
      background: isDark ? "rgba(15,23,42,0.95)" : "rgba(255,255,255,0.98)",
      border: `1px solid ${isDark ? "rgba(255,255,255,0.15)" : "rgba(0,0,0,0.08)"}`,
      borderRadius: 12,
      boxShadow: isDark ? "0 12px 32px rgba(0,0,0,0.5)" : "0 12px 32px rgba(0,0,0,0.12)",
      backdropFilter: "blur(12px)",
      color: isDark ? "#f1f5f9" : "#1e293b",
      fontSize: 12,
      padding: "8px 12px",
    },
    labelStyle: { color: isDark ? "#cbd5e1" : "#64748b", fontWeight: 600, marginBottom: 4 },
  };
};

export const CHART_PALETTE = ["#3b82f6", "#10b981", "#f59e0b", "#ef4444", "#8b5cf6", "#06b6d4", "#ec4899", "#84cc16"];
